<template>
  <div class="timeseries-filters">
    <v-row>
      <v-col cols="12" md="3">
        <v-select
          v-model="kitchen"
          :items="sortedKitchens"
          label="Kitchen *"
          item-text="id"
          menu-props="auto"
          placeholder="Kitchen..."
          prepend-icon="mdi-store"
          return-object
          clearable
          dense
          :rules="[(v) => !!v || 'Kitchen is required']"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="conceptUuid"
          :items="sortedConcepts"
          label="Concept"
          item-value="uuid"
          item-text="label"
          menu-props="auto"
          placeholder="Concept..."
          prepend-icon="mdi-lightbulb-outline"
          clearable
          dense
        >
          <template v-slot:item="props">
            <v-avatar size="36px" tile>
              <v-img :src="props.item.logo" contain class="pa-2" />
            </v-avatar>
            <div class="mx-4">{{props.item.label}}</div>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-dialog
          ref="startDialog"
          v-model="startModal"
          :return-value.sync="startDate"
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              label="Start date *"
              prepend-icon="mdi-calendar"
              readonly
              clearable
              dense
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || 'Start date is required']"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate" scrollable color="red accent-2">
            <v-spacer></v-spacer>
            <v-btn text color="red accent-2" @click="startModal = false">Cancel</v-btn>
            <v-btn text color="red accent-2" @click="$refs.startDialog.save(startDate)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" md="3">
        <v-dialog ref="endDialog" v-model="endModal" :return-value.sync="endDate" width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              label="End date *"
              prepend-icon="mdi-calendar"
              readonly
              clearable
              dense
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || 'End date is required']"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate" scrollable color="red accent-2">
            <v-spacer></v-spacer>
            <v-btn text color="red accent-2" @click="endModal = false">Cancel</v-btn>
            <v-btn text color="red accent-2" @click="$refs.endDialog.save(endDate)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col>
        <v-dialog
          ref="startMinuteDialog"
          v-model="startMinuteModal"
          :return-value.sync="startMinute"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startMinute"
              label="Start time *"
              prepend-icon="mdi-timer"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[
                (v) => !!v || 'Start time is required',
              ]"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="startMinuteModal"
            color="red accent-2"
            v-model="startMinute"
            full-width
          >
            <v-spacer></v-spacer>
            <v-btn text color="red accent-2" @click="startMinuteModal = false">Cancel</v-btn>
            <v-btn text color="red accent-2" @click="$refs.startMinuteDialog.save(startMinute)">OK</v-btn>
          </v-time-picker>
        </v-dialog>
      </v-col>
      <v-col>
        <v-dialog
          ref="endMinuteDialog"
          v-model="endMinuteModal"
          :return-value.sync="endMinute"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endMinute"
              label="End time *"
              prepend-icon="mdi-timer"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || 'End time is required']"
            ></v-text-field>
          </template>
          <v-time-picker v-if="endMinuteModal" color="red accent-2" v-model="endMinute" full-width>
            <v-spacer></v-spacer>
            <v-btn text color="red accent-2" @click="endMinuteModal = false">Cancel</v-btn>
            <v-btn text color="red accent-2" @click="$refs.endMinuteDialog.save(endMinute)">OK</v-btn>
          </v-time-picker>
        </v-dialog>
      </v-col>
      <v-col>
        <v-dialog
          ref="intervalDialog"
          v-model="intervalModal"
          :return-value.sync="interval"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="interval"
              label="Interval *"
              prepend-icon="mdi-timelapse"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || 'Interval is required']"
            ></v-text-field>
          </template>
          <v-time-picker v-if="intervalModal" color="red accent-2" v-model="interval" full-width>
            <v-spacer></v-spacer>
            <v-btn text color="red accent-2" @click="intervalModal = false">Cancel</v-btn>
            <v-btn text color="red accent-2" @click="$refs.intervalDialog.save(interval)">OK</v-btn>
          </v-time-picker>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-center">
        <v-btn @click="getStats" color="success" :disabled="!isValid">Search</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    concepts: { type: Array },
    kitchens: { type: Array },
  },
  data: () => {
    return {
      kitchen: {},
      conceptUuid: "",
      startModal: false,
      startDate: "",
      endModal: false,
      endDate: "",
      startMinute: "",
      startMinuteModal: false,
      endMinute: "",
      endMinuteModal: false,
      interval: "",
      intervalModal: false,
    };
  },
  computed: {
    sortedConcepts() {
      let _concepts = [...this.concepts];
      return _concepts.sort((a, b) => (a.label > b.label ? 1 : -1));
    },
    sortedKitchens() {
      let _kitchens = [...this.kitchens];
      return _kitchens.sort((a, b) => (a.id > b.id ? 1 : -1));
    },
    isValid() {
      let isFilled = this.kitchen && Object.keys(this.kitchen).length;
      let areDatesOK =
        this.startDate &&
        this.startDate !== "" &&
        this.endDate &&
        this.endDate !== "" &&
        this.startDate <= this.endDate;
      let aretimesOK =
        this.startMinute &&
        this.startMinute !== "" &&
        this.endMinute &&
        this.endMinute !== "" &&
        this.interval &&
        this.interval !== "" &&
        this.startMinute < this.endMinute;
      return isFilled && areDatesOK && aretimesOK;
    },
  },

  methods: {
    getStats() {
      let payload = {
        kitchenUuid: this.kitchen.uuid,
        conceptUuid: this.conceptUuid,
        locationUuid: this.kitchen.location_uuid,
        startDate: this.startDate,
        endDate: this.endDate,
        startMinute: this.startMinute,
        endMinute: this.endMinute,
        interval: this.interval,
      };
      this.$emit("searchTimeseries", payload);
    },
  },
};
</script>
